
import { Component, Vue, Prop} from 'vue-property-decorator';

import Form6ProcessHeader from "@/components/process/Form6/components/Form6ProcessHeader.vue";
import { packageInfoType } from '@/types/Information';
import { form6StatusInfoType } from '@/types/Information/Form6';

@Component({
    components:{
        Form6ProcessHeader
    }
})
export default class SuccessSubmitForm6 extends Vue {

    @Prop({required: true})
    packageInfo!: packageInfoType;

    stepsCompleted = {} as form6StatusInfoType;  
    mountedData = false; 


    mounted() {
        this.mountedData = false;
        this.stepsCompleted = {
            first: true,
            second: true,
            third: true
        } 
        this.saveApplication(this.packageInfo);               
    }

    public saveApplication(newPackageInfo: packageInfoType) {

        const data = {
            packageNumber: newPackageInfo.packageNumber,
            packageUrl: newPackageInfo.eFilingUrl 
        } 

        const url = "/form6/efiling/"+newPackageInfo.fileNumber+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        this.$http.put(url, data, header)
        .then(res => {                            
            this.mountedData = true;
        }, err => {
            console.error(err);
            this.mountedData = true;
        });    
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
